import { useCallback, useState } from "react";
import * as s from "../AlertViewStyled";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import {
  AlertList,
  AlertType,
  AlertViewInfo,
} from "api/interfaces/alertInterface.interface";
import AlertChangeConfirm from "components/templates/modal/small/alert/AlertChangeConfirm";
import { useQueryClient } from "react-query";
import AlertTypeItem from "./AlertTypeItem";
import { filteringDiskAlertBoolean } from "utils/AlertUtil";
import SwipeList from "components/blocks/swiper/SwiperList";
import useAlertStatusCloseMutation from "hook/useAlertStatusCloseMutation";

interface Props {
  alertTypeList: AlertType[];
  currentAlert: AlertList;
  alertInfo: AlertViewInfo;
  onChangeCurrentAlert: (alertType: AlertType, value?: string) => void;
  onCheckNoConfirm: (value: boolean) => void;
  checkNoConfirm: boolean;
  onFinishClose: () => void;
}

const AlertTypeList = (props: Props) => {
  const queryClient = useQueryClient();

  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const alertListStyled = s.AlertTypeListStyled;

  const [isConfirmStatus, setIsConfirmStatus] = useState<boolean>(false);

  const mutationAlertStatusClose = useAlertStatusCloseMutation({
    onSuccess: () => {
      const isVideoLoss = props.currentAlert.type === "Video Loss";
      const isDiskAlert = filteringDiskAlertBoolean(props.currentAlert);

      const cameraList = props.alertTypeList[0].cameraList;
      const storageList = props.alertTypeList[0].storageList;

      // alertType 이 한개일때
      if (props.alertTypeList.length === 1) {
        /**
         * type Video Loss or Disk Alert 일 때는
         * cameraList 나 storageList 가 여러 개일 수 있기 떄문에
         * 예외처리해야함
         */
        if (isVideoLoss || isDiskAlert) {
          if (
            /**
             * videoloss 의 cameralist 나 diskAlert 의 storageList 가 1개 이상일 경우에
             *
             *  */
            (cameraList && cameraList.length > 1) ||
            (storageList && storageList.length > 1)
          ) {
            queryClient.invalidateQueries("alertTraceList");

            // cameraList 나 storageList 없을 경우 modal 닫기
            if ((isVideoLoss && !cameraList) || (isDiskAlert && !storageList)) {
              props.onFinishClose();
            }
          } else {
            props.onFinishClose();
          }
        } else {
          props.onFinishClose();
        }
      } else {
        queryClient.invalidateQueries("alertTraceList");
      }
    },
  });

  const onMutateAlertStatusClose = () => {
    // console.log("onMutateAlertStatusClose", props.currentAlert);
    mutationAlertStatusClose.mutate({
      accountId: selectedAccount.accountId,
      recorderId: props.alertInfo.recorderId,
      historyId: props.currentAlert.alertHistoryId,
    });
  };

  const onConfirmCancel = () => {
    setIsConfirmStatus(false);
  };

  const onConfirmOk = (checked: boolean) => {
    if (checked) {
      props.onCheckNoConfirm(true);
    }

    setIsConfirmStatus(false);
    onMutateAlertStatusClose();
  };
  const onChangeStatus = useCallback(
    (value: string) => {
      if (value !== "Closed") {
        return;
      } else {
        if (!props.checkNoConfirm) {
          setIsConfirmStatus(true);
        } else {
          onMutateAlertStatusClose();
        }
      }
    },
    [isConfirmStatus, props.checkNoConfirm]
  );

  return (
    <>
      <alertListStyled.Wrapper>
        <SwipeList
          items={props.alertTypeList.map(
            (alertType: AlertType, index: number) => {
              return (
                <AlertTypeItem
                  key={index}
                  alertType={alertType}
                  currentAlert={props.currentAlert}
                  onChangeCurrentAlert={props.onChangeCurrentAlert}
                  onChangeStatus={onChangeStatus}
                />
              );
            }
          )}
          SwiperWrapper={alertListStyled.Wrapper}
          SwiperItem={alertListStyled.Item}
        />
      </alertListStyled.Wrapper>
      {isConfirmStatus && !props.checkNoConfirm && (
        <AlertChangeConfirm
          onConfirmCancel={onConfirmCancel}
          onConfirmOk={onConfirmOk}
          alertInfo={props.alertInfo}
          currentAlert={props.currentAlert}
        />
      )}
    </>
  );
};

export default AlertTypeList;
